// ErrorState — failure placeholder (PSD §10.8). Presentation.

import type { ReactNode } from 'react';
import { X } from 'lucide-react';

interface ErrorStateProps {
  icon?: ReactNode;
  message: string;
  detail?: string;
  action?: ReactNode;
}

export function ErrorState({ icon, message, detail, action }: ErrorStateProps) {
  return (
    <div className="error-state" role="alert">
      <div className="error-state-icon" aria-hidden="true">
        {icon ?? <X size={28} strokeWidth={1.5} />}
      </div>
      <p>{message}</p>
      {detail && <p style={{ fontSize: 'var(--font-size-1)' }}>{detail}</p>}
      {action}
    </div>
  );
}
